/*
  Dtcs state
*/
export default {
  // getList and getActiveList run concurrently and feed different lists,
  // so they need separate flags
  loading: false,
  activeListLoading: false,
  underinflationEvents: [],
  dictUndernflationEvents: [],
  fastPressureLostEvents: [],
  dictFastPressureLostEvents: [],
  overheatingEvents: [],
  dictOverheatingEvents: [],
  list: [],
  dictList: {},
  tpmsWarnings: [],
  tpmsEvents: [],
  timeListWarnings: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  },
  timeListEvents: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  },
  activeList: []
}
